module.exports = __webpack_public_path__ + "img/1522092639.6ad33726.jpg";